import React from 'react';
import Flex from '@wix/da-ds/pkg/Flex';
import TierPricePerMonth from '../TierPricePerMonth';

import s from './TierPriceWithBadge.scss';

export interface Props {
  price?: string;
  showPlaceholder?: boolean;
  className?: string;
}

const TierPriceWithBadge: React.FC<Props> = ({ price, showPlaceholder, className }) => {
  return (
    <Flex alignItems="center" className={className}>
      {showPlaceholder && !price ? (
        <span className={s['placeholder']} />
      ) : (
        <TierPricePerMonth price={price} />
      )}
    </Flex>
  );
};
TierPriceWithBadge.displayName = 'TierPriceWithBadge';

export default TierPriceWithBadge;
